var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 19L13.4453 17.5",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80865 15H0.875V0H5.90817C7.35367 0 8.59538 0.300293 9.63329 0.900879C10.6759 1.49658 11.4769 2.35352 12.0361 3.47168C12.5954 4.58984 12.875 5.92773 12.875 7.48535C12.875 9.04785 12.593 10.3906 12.029 11.5137C11.4698 12.6367 10.6617 13.4985 9.60486 14.0991C8.55272 14.6997 7.28732 15 5.80865 15ZM3.51244 12.6489H5.68069C6.69491 12.6489 7.54088 12.4585 8.2186 12.0776C8.89633 11.6919 9.40581 11.1182 9.74704 10.3564C10.0883 9.58984 10.2589 8.63281 10.2589 7.48535C10.2589 6.33789 10.0883 5.38574 9.74704 4.62891C9.40581 3.86719 8.90107 3.29834 8.23282 2.92236C7.56931 2.5415 6.74467 2.35107 5.75889 2.35107H3.51244V12.6489Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.e233992b02453d3b8daf9b8ef4b4b2a6.svg";
export { ForwardRef as ReactComponent };